import { useSnapshot } from 'valtio';

import { userStatusState } from '..';
import { serviceState } from '@modules/ServiceModule/workspace';

/**
 * Returns status, loading, and error states for the user status.
 *
 * The error and loading states are composed with the service state
 * to provide a more accurate representation of the user status.
 */
function useUserStatus() {
  const state = useSnapshot(userStatusState);
  const { loading, error } = useSnapshot(serviceState);

  return {
    status: state.status,
    canChange: state.canChange,
    loading: state.loading || loading,
    error: state.error || error,
  };
}

export default useUserStatus;
